import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HandsetService } from 'src/app/core/services/handset.service';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-liability-scan-completed',
  styleUrls: ['./liability-scan-completed.component.scss'],
  templateUrl: './liability-scan-completed.component.html',
})
export class LiabilityScanCompletedComponent implements OnInit{
  public liabilityId: string;
  public verified: boolean;

  constructor(
    public handsetService: HandsetService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toolbar: ToolbarService,
  ) {
    this.toolbar.init(this.activatedRoute);
    this.liabilityId = this.activatedRoute.snapshot.params.id;
  }


  onShowLiability() {
    this.router.navigateByUrl('/liabilities/' + this.liabilityId);
  }
  public ngOnInit() {
    this.activatedRoute.data.subscribe((data: { verified: boolean }) => {
      this.verified = data.verified;
    });

  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
